import styled from 'styled-components'

export const StyledStatsBar = styled.div`
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    align-items: center;
`

export const Item = styled.span`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0.3125rem;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-font-smoothing: antialiased;
`

export const Separator = styled.span`
    margin: 0 0.1875rem;
`
